import api, { IPaginationResponse } from 'config/axios';

import AppService from 'common/app-service';
import { IUserRegistry, RegisterStatusTypes } from 'common/user.interface';

interface IPersonQueryParams {
  roleType?: 'admin' | 'customer';
  email?: string;
}

export default class PersonService extends AppService {
  constructor() {
    super('persons', api);
  }

  async getById(id: number): Promise<IUserRegistry> {
    const response = await this.api.get(this.root(id));
    return response.data;
  }

  async all({ email, roleType }: IPersonQueryParams, page?: number, limit?: number): Promise<IPaginationResponse<IUserRegistry>> {
    const response = await this.api.get(this.root(), {
      params: {
        email,
        roleType: roleType === 'admin' ? 'torqi_admin' : ['torqi_customer_operator', 'torqi_customer_supervisor', 'torqi_customer_owner'],
        ...(page && limit ? { page, limit } : {}),
      },
    });
    return response.data;
  }

  async edit(id: number | string, params: Partial<IUserRegistry>): Promise<IUserRegistry> {
    const response = await this.api.put(this.root(id), params);
    return response.data;
  }

  async getCount({ registerStatusType }: { registerStatusType: RegisterStatusTypes }): Promise<any> {
    const response = await this.api.get(this.root('customers/count'), {
      params: {
        registerStatusType,
      },
    });
    return response.data.count;
  }
}
